import { useQuery } from '@tanstack/react-query';
import ApiRoutes from 'src/constants/ApiRoutes';
import { getHeaders } from 'src/services/api';
import { ApiError } from 'src/types/Api';

type WaitTimeRequest = {
    quizToken: string;
};
type WaitTimeResponse = {
    waitStage: 'short' | 'long' | 'several_days' | 'none';
    waitTime: string;
};

async function getWaitTime(params: WaitTimeRequest): Promise<WaitTimeResponse> {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const res = await fetch(
        ApiRoutes.CONSULT_CALCULATE_WAIT_TIME(params.quizToken, timezone),
        {
            method: 'GET',
            headers: getHeaders(),
        },
    );
    const data = await res.json();
    if (!res.ok) {
        throw data as ApiError;
    }

    return data as WaitTimeResponse;
}

export const useWaitTime = (params: WaitTimeRequest, enabled = true) => {
    return useQuery<WaitTimeResponse, ApiError>({
        queryKey: ['WaitTime', params.quizToken],
        queryFn: () => getWaitTime(params),
        enabled: !!params.quizToken && enabled,
    });
};
